import { c as _c } from "react/compiler-runtime";
import { t } from '@sizzlenz/shared';
import * as _ from 'es-toolkit';
import Link from 'next/link';
type FooterColumnGroup = Array<FooterColumn>;
type FooterColumn = {
  title: string;
  links: Array<{
    label: string;
    href: string;
    disabled?: boolean;
    hidden?: boolean;
  }>;
};
const footerColumns: FooterColumnGroup[] = _.compact([[{
  title: 'Go',
  links: [{
    label: 'Free Help',
    href: '/concierge'
  }, {
    label: 'Opportunities',
    href: '/opportunities'
  },
  // { label: 'Export Central', href: '/export' },
  {
    label: 'Inspiration Feed',
    href: '/inspiration-feed'
  }, {
    label: 'Collaborations Central',
    href: '/content/collaborations-central'
  },
  // { href: '/content?type=news', label: 'News' },
  // { label: 'Spark: Be Inspired, Take Action', href: '/spark' },
  // { label: 'Initiative Starters', href: '/initiative-starters' },
  // { label: 'Discover & Do', href: '/consumer/discover-do' },
  // { label: 'Trade Opportunities', href: '/opportunities' },
  // { label: 'Asks', href: '/asks' },
  // { label: 'Host', href: '/host-opportunities' },
  // { label: 'Spaces', href: '/spaces' },
  {
    label: 'Hubs',
    href: '/hubs'
  }, {
    label: 'Directory',
    href: '/directory'
  }, {
    label: 'Master Demand 101',
    href: '/demand'
  }, {
    label: 'Office Hours',
    href: '/content/office-hours?tab=whatson'
  }
  // { label: 'Themes', href: '/themes' },
  // { label: 'Collections', href: '/collections' },
  ]
}],
// [
//   {
//     title: 'Solution',
//     links: _.compact([
//       { label: 'Sizzle for Industry', href: '/for-industry' },
//       { label: 'Sizzle for Brands', href: '/for-brands' },
//       { label: 'Sizzle for Buyers', href: '/for-buyers' },
//       { label: 'Sizzle for Independent Retailers', href: '/for-independent-retailers' },
//       { label: 'Sizzle for Places', href: '/for-places' },
//       { label: 'Sizzle for Events', href: '/for-events' },
//       // { label: 'Sizzle for Spaces', href: '/for-places' },
//     ]),
//   },
// ],

// process.env.SIZZLE_PLATFORM == 'sizzlenz'
//   ? [
//       {
//         title: 'Resources',
//         links: _.compact([
//           process.env.SIZZLE_PLATFORM == 'sizzlenz'
//             ? {hidden: true, label: 'NZ Trade Hub', href: '/nz-trade-hub' }
//             : null,
//           ,
//           { hidden: true, label: 'Food Rescue & Upcycling', href: '/food-rescue-upcycling' },
//         ]),
//       },
//     ]
//   : null,
// [
//   {
//     title: 'Resources',
//     links: [
//       { label: 'Tools Library', href: '/tools' },
//       {
//         label: 'NZ Export Reality Check',
//         href: '/tools/export-reality-check',
//       },
//       {
//         label: 'Glowpath Australian Retail Readiness Assessment',
//         href: '/tools/au-retail-readiness-report',
//       },
//     ],
//   },
// ],
[{
  title: 'Company',
  links: [{
    label: 'About',
    href: '/about'
  }, {
    label: 'Privacy Policy',
    href: '/privacy'
  }, {
    label: 'Terms of Service',
    href: '/terms'
  }]
}]]);
export default function Footer() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="md:col-span-1"><Link href="/" className="flex items-center gap-2"><div className="w-9 h-9 bg-gradient-to-br from-primary-500 to-primary-700 rounded-xl flex items-center justify-center"><svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" /></svg></div><span className="text-xl font-bold bg-gradient-to-r from-primary-600 to-primary-500 bg-clip-text text-transparent">Sizzle</span></Link></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-16">{t0}<div className="md:col-span-4 grid grid-cols-2 md:grid-cols-4 gap-8">{footerColumns.map(_temp5)}</div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="text-sm text-gray-500">© {new Date().getFullYear()} Sizzle CPG. All rights reserved.</p>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = t("footer.email");
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <a href={`mailto:${t3}`} className="hover:text-primary-500 transition-colors cursor-pointer"><svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a1.75 1.75 0 01-1.644 0L1.5 8.67z" /><path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a.25.25 0 00.235 0L22.5 6.908z" /></svg></a>;
    t5 = t("footer.linkedinUrl");
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <footer className="bg-white border-t border-gray-100"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">{t1}<div className="pt-8 border-t border-gray-50 flex flex-col md:flex-row justify-between items-center gap-6">{t2}<div className="flex items-center gap-8 text-gray-400">{t4}<a href={t5} target="_blank" rel="noopener" className="hover:text-primary-500 transition-colors cursor-pointer"><svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.25 6.5 1.75 1.75 0 016.5 8.25zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.54c1.39 0 3.4.81 3.4 4V19z" /></svg></a><Link href="/privacy" className="text-sm hover:text-gray-900 transition-colors cursor-pointer">Privacy Policy</Link><Link href="/accessibility" className="text-sm hover:text-gray-900 transition-colors cursor-pointer">Accessibility</Link></div></div></div>{t("footer.skimlinksFileId") ? <script type="text/javascript" src={`https://s.skimresources.com/js/${t("footer.skimlinksFileId")}.skimlinks.js`} /> : null}</footer>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
function _temp5(column, colIndex) {
  return <div key={colIndex} className="flex flex-col gap-8">{column.filter(_temp).map(_temp4)}</div>;
}
function _temp4(section_0) {
  return <div key={section_0.title}><h3 className="text-sm font-bold text-gray-900 uppercase tracking-widest mb-4">{section_0.title}</h3><ul className="space-y-2">{section_0.links.filter(_temp2).map(_temp3)}</ul></div>;
}
function _temp3(link) {
  return <li key={link.label}>{!link.disabled ? <Link href={link.href} className="text-gray-500 hover:text-primary-600 transition-colors text-md cursor-pointer">{link.label}</Link> : <div className="text-gray-400 cursor-default">{link.label}</div>}</li>;
}
function _temp2(l) {
  return !l.hidden;
}
function _temp(section) {
  return section.links.length;
}